// XNGAGE CONFIDENTIAL
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";

interface OwnProps {
    title: string;
    userId: string;
    // XNG-Change
    onClick?: () => void;
}

type Props = OwnProps;

const UserSetupPageTypeLink: React.FunctionComponent<Props> = ({ title, userId, onClick }) => {
    return createWidgetElement("Basic/PageTypeLink", {
        fields: {
            pageType: "UserSetupPage",
            overrideTitle: title,
            queryString: `userId=${userId}`,
            // XNG-Change
            onClick,
        },
    });
};

export default UserSetupPageTypeLink;

